export default __webpack_public_path__ + "static/media/signal-svg.b77af926.svg";